let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fw2TG")).then(() => parcelRequire('8NFT3'));